import { IScope } from "angular";
import { IModalServiceInstance } from "angular-ui-bootstrap";

import { IPlanningSession, IPlanningSessionConflict } from "../models/models";
import { ICollection } from "@gtmhub/models";
import { IAssigneeIdMap } from "@gtmhub/assignees/models";
import { IUIError, UIErrorHandlingService } from "@gtmhub/error-handling";
import { AssigneeActions, IAssigneesStoreState } from "@gtmhub/assignees";
import { INgRedux } from "@gtmhub/state-management";
import { IExtendedRootScopeService } from "@gtmhub/shared/ng-extensions";

export interface IPlanningSessionConflictsScope extends IScope, IExtendedRootScopeService {
  indicators: {
    loading: boolean;
  };
  session: IPlanningSession;
  conflicts: ICollection<IPlanningSessionConflict>;
  assignees: IAssigneeIdMap;
  assigneesFetched: boolean;
  assigneesError: IUIError;
  ignoreAndClone: boolean;
  close(): void;
  save(): void;
}

const bindStateToScope = (state: IAssigneesStoreState) => {
  const { map: assignees, isFetched: assigneesFetched, error: assigneesError } = state.assignees;

  return {
    assignees,
    assigneesFetched,
    assigneesError,
  };
};
export class PlanningSessionConflictsCtrl {
  public static $inject = ["$scope", "UIErrorHandlingService", "$uibModalInstance", "conflicts", "session", "onSave", "ignoreAndClone", "AssigneeActions", "$ngRedux"];

  constructor(
    private $scope: IPlanningSessionConflictsScope,
    private uiErrorHandlingService: UIErrorHandlingService,
    private $uibModalInstance: IModalServiceInstance,
    private conflicts: ICollection<IPlanningSessionConflict>,
    private session: IPlanningSession,
    private onSave: () => void,
    private ignoreAndClone: boolean,
    private assigneeActions: AssigneeActions,
    private $ngRedux: INgRedux
  ) {
    const unsubscribe = this.$ngRedux.connect(bindStateToScope)(this.$scope);
    this.$scope.$on("$destroy", unsubscribe);

    this.init();
  }

  private init = (): void => {
    this.$ngRedux.dispatch(this.assigneeActions.getAssignees());

    this.$scope.indicators = {
      loading: true,
    };
    this.$scope.ignoreAndClone = this.ignoreAndClone;

    this.$scope.session = this.session;
    this.$scope.conflicts = this.conflicts;
    this.$scope.save = this.onSave;

    this.$scope.close = () => {
      this.$uibModalInstance.close();
    };

    this.$scope
      .watchUntilAndRejectOnError(
        () => this.$scope.assigneesFetched,
        () => this.$scope.assigneesError
      )
      .then(
        () => (this.$scope.indicators.loading = false),
        () => this.uiErrorHandlingService.handleIndicator(this.$scope.assigneesError, { indicator: "loading" })
      );
  };
}
